import { gql, useQuery } from '@apollo/client';
import cx from 'classnames';
import { string } from 'prop-types';

import CampaignPageSectionHeader from './CampaignPageSectionHeader';
import CampaignPagePhotoGalleryGrid from './CampaignPagePhotoGalleryGrid';
import CampaignPagePhotoGalleryCarousel from './CampaignPagePhotoGalleryCarousel';

const GET_WIDGET = gql`
  query GetCampaignPagePhotoGallery($id: String!) {
    findCampaignWidgets(id: $id) {
      id
      title
      config
    }
  }
`;

const CampaignPagePhotoGallery = ({ id, className }) => {
  const { data } = useQuery(GET_WIDGET, { variables: { id } });
  const block = data?.findCampaignWidgets[0];
  const images = block?.config.images ?? [];
  const type = block?.config.type;

  if (!block) return null;
  return (
    <div
      className={cx('py-16 bg-white', className)}
      style={{ backgroundColor: block?.config?.backgroundColor }}
    >
      <div className="container max-w-7xl">
        {block.title && (
          <CampaignPageSectionHeader
            title={block.title}
            titleClassName="text-gray-800"
            style={{ color: block?.config.titleColor }}
          />
        )}
        <div>
          {type == 'grid' && <CampaignPagePhotoGalleryGrid images={images} />}
          {type == 'carousel' && <CampaignPagePhotoGalleryCarousel images={images} />}
        </div>
      </div>
    </div>
  );
};

CampaignPagePhotoGallery.propTypes = {
  id: string.isRequired,
  className: string,
};

CampaignPagePhotoGallery.defaultProps = {
  className: '',
};

export default CampaignPagePhotoGallery;
